import { LitElement, html, css } from "lit";
import dayjs from "dayjs";
import language from "#scripts/translation";
import { ensureLogedin } from "#scripts/idporten.js";

export class MyPageMessages extends LitElement {
	static properties = {
		yearfilter: { reflect: true },
	};

	static styles = css`
    :host {
      width: 100%;
    }
    .messages {
      display: flex;
      border-top: 2px solid rgba(0, 0, 0, 0.2);
      padding-top: 65px;
      margin-top: 30px;
      @media(max-width: 768px) {
        flex-direction: column;
        border-top: none;
        padding-top: 0px;
        margin-top: 0px;
      }
    }
    `;

	render () {
		return html`
        <div class="messages" @messages-filtered-year=${this._handleYearFilter}>
          <slot></slot>
      </div>`;
	}

	_handleYearFilter (e) {
		this.yearfilter = e.detail.message;
		// update all children that uses filter
		const invoicesList = document.querySelector("mypage-messages-list");
		invoicesList.yearfilter = this.yearfilter;
	}
}

export class MyPageMessagesFilter extends LitElement {
	static properties = {
		yearfilter: { type: String, state: true, reflect: true },
		ssn: { type: String },
	};

	static styles = css`
    .filter {
      width: 240px;
      position: relative;
      padding: 0px;
      display: flex;
      flex-direction: column;
      gap: 30px;
      align-items: flex-start;
      justify-content: flex-start;
      width: 100%;
      @media(max-width: 768px) {
        display: none;
        gap: 20px;
        width: auto;
        border-radius: 6px;
        padding: 20px;
        background: rgb(255 255 255 / .8);
        margin-bottom: 20px;
      }
    }
    .filter-toggle {
      font-size: 1rem;
      display: flex;
      justify-content: flex-end;
      padding-bottom: 10px;
      & div {
        display: flex;
      }
      & svg {
        position: relative;
      }
      @media(min-width: 768px) {
        display: none;
      }
      &.active svg {
        transform: rotate(180deg);
      }
      &.active + .filter {
        display: flex;
      }
    }
    .filter-header {
      color: #000000;
      font-size: var(--raelingen-h3-font-size, 20px);
      font-weight: var(--raelingen-h3-font-weight, 600);
    }
    .filter-group {
      display: flex;
      flex-direction: column;
      gap: 0px;
      align-items: flex-start;
      justify-content: flex-start;
      flex-shrink: 0;
      position: relative;
      margin-top:  10px;
    }
    .filter-title {
      display: flex;
      height: 50px;
      align-content: center;
      flex-wrap: wrap;
    }
    .dato {
      color: #000000;
      text-align: left;
      font-family: var(--trekkspill-tekst-font-family, "Roboto-Medium", sans-serif);
      font-size: var(--trekkspill-tekst-font-size, 18px);
      line-height: var(--trekkspill-tekst-line-height, 24px);
      font-weight: var(--trekkspill-tekst-font-weight, 500);
      position: relative;
    }
    .cells {
      display: flex;
      width: 292px;
      flex-direction: column;
    
    .check-cell {
			padding: 14px 0;
      @media(min-width: 768px) {
				padding: 16px 0;
      }
		}
		
    .check {
      display: flex;
      gap: 10px;
    }
		input[type=checkbox],
    input[type=radio] {
        transform: scale(1.5);
				accent-color: var(--black__text);
    }
    `;

	// constructor() {
	// 	super();
	// }

	render () {
		return html`  
      <div class="filter-toggle" @click=${this._handleFilterToggle}>
        <div>Filter</div>
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" width="24px" viewBox="0 -960 960 960" fill="var(--black__text)"><path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z"/></svg>
      </div> 
      <div class="filter">
        <div class="filter-header">${language("MYPAGE_POST_FILTER_TITLE")}</div>
      <div class="filter-group">
        <div class="filter-title">
          <div class="dato">${language("MYPAGE_POST_FILTER_YEAR")}</div>
        </div>
          <div class="cells">
          <div class="check-cell">
            <label class="check"><input type="radio" name='year_filter' @click=${this._handleYearCheck
			} data-filtervalue=${new Date().getFullYear()} checked>${new Date().getFullYear()}</label>
          </div>
          <div class="check-cell">
            <label class="check"><input type="radio" name='year_filter' @click=${this._handleYearCheck} data-filtervalue=${new Date().getFullYear() - 1}>${new Date().getFullYear() - 1
			}</label>
          </div>
          <div class="check-cell">
            <label class="check"><input type="radio" name='year_filter' @click=${this._handleYearCheck} data-filtervalue=${new Date().getFullYear() - 2}>${new Date().getFullYear() - 2
			}</label>
          </div>
          <div class="check-cell">
            <label class="check"><input type="radio" name='year_filter' @click=${this._handleYearCheck} data-filtervalue=${new Date().getFullYear() - 3}>${new Date().getFullYear() - 3
			}</label>
          </div>
          <div class="check-cell">
            <label class="check"><input type="radio" name='year_filter' @click=${this._handleYearCheck} data-filtervalue=${new Date().getFullYear() - 4}>${new Date().getFullYear() - 4
			}</label>
          </div>
        </div>
        </div>
    </div>
    `;
	}

	_handleYearCheck (event) {
		const detail = {
			message: event.target.checked ? event.target.dataset.filtervalue : "",
		};
		const options = {
			detail,
			bubbles: true,
			composed: true,
		};
		this.dispatchEvent(new CustomEvent("messages-filtered-year", options));
	}

	_handleFilterToggle (event) {
		event.preventDefault();
		const link = event.target;
		link.parentElement.classList.toggle("active");
	}
}

export class MyPageMessagesList extends LitElement {
	static properties = {
		yearfilter: { type: String, state: true, reflect: true },
	};

	static styles = css`
    :host {
      width: 100%;
    }

    .list__container {
      margin-inline: auto;
      padding-bottom: 30px;
      width: 100%;
      max-width: 1140px; 
      justify-content: space-between;
    }
    .list__items {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      gap: 30px;
			@media(max-width: 768px) {
        gap: 20px;
			}
    }
		/* HTML: <div class="loader"></div> */
    .loader {
      align-self: center;
      width: 50px;
      padding: 8px;
      aspect-ratio: 1;
      border-radius: 50%;
      background: var(--spinner-color, var(--primary__color, #444));
      --_m: 
        conic-gradient(#0000 10%,#000),
        linear-gradient(#000 0 0) content-box;
      -webkit-mask: var(--_m);
              mask: var(--_m);
      -webkit-mask-composite: source-out;
              mask-composite: subtract;
      animation: l3 1s infinite linear;
    }
    @keyframes l3 {to{transform: rotate(1turn)}}
  `;

	// constructor() {
	//   super();
	// }

	render () {
		let year = new Date().getFullYear();
		if (this.yearfilter !== undefined && this.yearfilter !== "") {
			year = this.yearfilter;
		}
		const messageList = document.querySelector("mypage-messages-list");

		getMessages(year).then((data) => {
			messageList.replaceChildren();
			if (data?.treff !== undefined) {
				const messages = data?.treff;
				for (const item of messages) {
					const messageCard = document.createElement("mypage-message-item");
					messageCard.item = item;
					messageList.appendChild(messageCard);
				}
				if (messageList.children.length < 1) {
					const messageeError = document.createElement("mypage-message-error");
					messageeError.message = language("MYPAGE_POST_NOMESSAGES");
					messageList.appendChild(messageeError);
				}
			} else {
				const messageeError = document.createElement("mypage-message-error");
				messageeError.message = data?.message ?? data;
				messageList.appendChild(messageeError);
			}
		});

		return html`<div class="list__container">
									<div class="list__items">
										<slot><div class="loader"></div></slot>
									</div>
								</div>`;
	}
}

export class MyPageMessageItem extends LitElement {
	static properties = {
		item: { type: Object, reflect: true },
	};

	static styles = css`
    .item {
      background: #ffffff;
      border-radius: 6px;
      padding: 20px;
      display: flex;
      flex-direction: row;
      gap: 20px;
      align-items: flex-start;
      justify-content: flex-start;
      flex-shrink: 0;
      position: relative;
			cursor: pointer;
			&:hover {
				box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.25);
			}
			@media(max-width: 768px) {
				padding: 20px 10px 20px 20px;
			}
    }
    .icon {
      padding: 5px 0px 0px 0px;
      display: flex;
      flex-direction: row;
      gap: 10px;
      align-items: flex-start;
      justify-content: flex-start;
      flex-shrink: 0;
      position: relative;
      flex-shrink: 0;
      width: 37px;
      height: auto;
      position: relative;
      img {
        width: 32px;
      }
    }
    .content {
      display: flex;
      flex-direction: column;
      gap: 10px;
      align-items: flex-start;
      justify-content: flex-start;
      align-self: stretch;
      flex: 1;
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 0px;
      align-items: flex-start;
      justify-content: flex-start;
      align-self: stretch;
      flex-shrink: 0;
      position: relative;
    }
    .title {
      display: flex;
      flex-direction: row;
      gap: 0px;
      align-items: flex-start;
      justify-content: flex-start;
      align-self: stretch;
      flex-shrink: 0;
      position: relative;
      color: var(--default-500, #1e1e1e);
      text-align: left;
      font-family: var(
        --raelingen-h3-font-family,
        "SourceSansPro-SemiBold",
        sans-serif
      );
      font-size: var(--raelingen-h3-font-size, 20px);
      line-height: var(--raelingen-h3-line-height, 150%);
      font-weight: var(--raelingen-h3-font-weight, 600);
      position: relative;
      flex: 1;
    }
    .text {
      color: var(--default-500, #1e1e1e);
      text-align: left;
      font-family: "SourceSansPro-Regular", sans-serif;
      font-size: 16px;
      line-height: 135%;
      font-weight: 400;
      position: relative;
      align-self: stretch;
    }
    .more-icon {
      display: flex;
      flex-direction: column;
      gap: 10px;
      align-items: flex-end;
      justify-content: center;
      align-self: stretch;
      flex-shrink: 0;
      position: relative;
    }
    .arrow-forward {
      flex-shrink: 0;
      width: 32px;
      height: 32px;
      position: relative;
      overflow: visible;
    }
		.message-dialog {
      padding: 50px 30px 40px 30px;
      border-radius: 6px;
      background: #FFF;
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
      border: none;
			& .icon {
				padding: none;
				width: 50px;
				& img {
					width: 50px;
				}
			}
      & .dlg-close {
        position: absolute;
        top: 10px;
        right: 10px;
      }
      & .dlg-wrapper {
        display: inline-flex;
        align-items: flex-start;
        flex-direction: column;
        gap: 30px;
				min-width: 600px;
      }
			& .message-head,
			& .message-footer {
				display: flex;
				gap: 20px;
				width: -webkit-fill-available;
			}
			& .message-head {
				.text {
					display: grid;
    			grid-template-columns: 1fr 2fr;
    			gap: 5px;
				}
			}
			& .message-attachemnts{
				width: -webkit-fill-available;
				& fieldset {
					border-width: 1px;
					border-radius: 4px;
				}
				& ul {
					list-style-type: none;
					padding-inline-start: 0;
          margin-block: 0;
				}
				& a {
					display: flex;
    			gap: 10px;
				}
			}
      & .dlg-title {
        color: var(--black__text, #1E1E1E);
        font-size: 21px;
        font-weight: var(--f-w-3);
      }
      & .dlg-text {
        color: var(--black__text, #1E1E1E);
        font-size: 18px;
        max-width: 310px;
      }
			& a.dlg-text:focus-visible {
				outline: none;
			}
      & .dlg-button-row {
        display: flex;
        align-items: flex-start;
        gap: 10px;
				width: -webkit-fill-available;
        justify-content: flex-end;
      }
      & button {
        display: flex;
        padding: 16px 32px;
        align-items: flex-start;
        gap: 12px;
        border: 2px solid var(--primary__color, #004459);
        font-size: 18px;
        font-weight: 500;
        line-height: 24px;
        cursor: pointer;
      }
      & button.disabled {
        cursor: default;
        opacity: .5;
      }
      & button.dlg-cancel {
        border-radius: 4px;
        background: #FFF;
        color: var(--primary__color, #004459);
      }
      & button.dlg-ok {
        border-radius: 4px;
        background: var(--primary__color, #004459);
        color: var(--white__text)
      }
      &::backdrop {
        /* opacity: 0.75; */
        background-color: rgba(0, 0, 0, 0.60);
      }
    }`;

	// constructor() {
	//   super();
	// }

	render () {
		const icon = `https://static.fiks.ks.no/img/kommunevaapen/${this.item.fiksOrganisasjon?.kommunenummer}.png`;

		return html`
			<div class="item" @click=${this._handleMessageOpenClick}>
				<div class="icon">
					<img loading="lazy" src="${icon}" />
				</div>
				<div class="content">
					<div class="title">
						${this.item.meldingMetadata.tittel}
					</div>
					<div class="text">
						${language("MYPAGE_POST_LABEL_FROM")} ${this.item.fiksOrganisasjon?.visningsnavn}
						<br />
						${language("MYPAGE_POST_LABEL_DATE")} ${dayjs(this.item.meldingMetadata.sendtDato).format("DD MMM YYYY")}
					</div>
				</div>
				<a href="${this.item.meldingMetadata.dokumenter[0].nedlastingLenke}">
					<div class="more-icon">
						<svg class="arrow-forward" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
							<mask id="mask0_2397_6727" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
								<rect width="32" height="32" fill="#D9D9D9" />
							</mask>
							<g mask="url(#mask0_2397_6727)">
								<path d="M15.7037 26.6673L13.8565 24.8007L21.1158 17.334H5.33337V14.6673H21.1158L13.8565 7.20065L15.7037 5.33398L26.0741 16.0007L15.7037 26.6673Z"
									fill="#1E1E1E" />
							</g>
						</svg>
					</div>
				</a>
      </div>
			<dialog class="message-dialog">
				<div class="dlg-close" @click=${this._handleCloseClick}>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
              <mask id="mask0_2654_2693" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
              <rect width="32" height="32" fill="#D9D9D9"/>
              </mask>
              <g mask="url(#mask0_2654_2693)">
              <path d="M8.53335 25.3327L6.66669 23.466L14.1334 15.9993L6.66669 8.53268L8.53335 6.66602L16 14.1327L23.4667 6.66602L25.3334 8.53268L17.8667 15.9993L25.3334 23.466L23.4667 25.3327L16 17.866L8.53335 25.3327Z" fill="#1E1E1E"/>
              </g>
            </svg>
          </div>
				<div class="dlg-wrapper">
					<div class="message-head">
						<div class="icon">
							<img loading="lazy" src="${icon}" />
						</div>
						<div class="text">
							<div>${language("MYPAGE_POST_DLG_TO")} </div><div>${this.item.meldingMetadata?.mottakerAdresse?.navn}</div>
							<div>${language("MYPAGE_POST_DLG_FROM")} </div><div>${this.item.meldingMetadata?.avsender}</div>
							<div>${language("MYPAGE_POST_DLG_DATE")} </div><div>${dayjs(this.item.meldingMetadata.sendtDato).format("DD MMM YYYY")}</div>
						</div>
					</div>
					<div class="message-attachemnts">
						<fieldset>
    					<legend>${language("MYPAGE_POST_DLG_ATTACHMENT")}</legend>
							<ul>
								${this.item.meldingMetadata.dokumenter.map(
			(doc) =>
				html`<li><a class="dlg-text" href="${doc.nedlastingLenke}"><svg xmlns="http://www.w3.org/2000/svg" height="24px" width="24px" viewBox="0 -960 960 960" fill="var(--black__text)"><path d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z"/></svg>${doc.tittel}</a></li>`,
		)}
							</ul>
						</fieldset>
					</div>
					<div class="message-footer">
            <div>
              <div class="dlg-title">${language("MYPAGE_POST_DLG_RECIPIENT_ADDRESS")}</div>
              <div class="dlg-text">
								<div>${this.item.meldingMetadata?.mottakerAdresse?.navn}</div>
								<div>${this.item.meldingMetadata?.mottakerAdresse?.addresselinje1}</div>
								${this.item.meldingMetadata?.mottakerAdresse?.addresselinje2 ?? `<div>${this.item.meldingMetadata?.mottakerAdresse?.addresselinje2}</div>`}
								${this.item.meldingMetadata?.mottakerAdresse?.addresselinje3 ?? `<div>${this.item.meldingMetadata?.mottakerAdresse?.addresselinje3}</div>`}
								<div>${this.item.meldingMetadata?.mottakerAdresse?.postnummer} ${this.item.meldingMetadata?.mottakerAdresse?.poststed}</div>
								${this.item.meldingMetadata?.mottakerAdresse?.land ?? `<div>${this.item.meldingMetadata?.mottakerAdresse?.land}</div>`}
							</div>
            </div>
					</div>
					<div class="dlg-button-row">
						<button class="dlg-ok" value="cancel" @click=${this._handleCancelClick}>${language("MYPAGE_POST_DLG_CLOSE")}</button>
					</div>
        </div>
      </dialog>`;
	}

	_handleMessageOpenClick (event) {
		const messageDialog = event.target.closest(".item").nextElementSibling;
		messageDialog.showModal();
	}

	_handleCloseClick (event) {
		const postponeDialog = event.target.closest(".message-dialog");
		postponeDialog.close();
	}

	_handleCancelClick (event) {
		const postponeDialog = event.target.closest(".message-dialog");
		postponeDialog.close();
	}
}

export class MyPageMessageError extends LitElement {
	static properties = {
		message: { type: String },
	};

	static styles = css`
    .item {
      background: #ffffff;
      border-radius: 6px;
      padding: 20px 25px 20px 25px;
      display: flex;
      flex-direction: row;
      gap: 20px;
      align-items: center;
      justify-content: flex-start;
      flex-shrink: 0;
      position: relative;
    }
    .icon {
      padding: 5px 0px 0px 0px;
      display: flex;
      flex-direction: row;
      gap: 10px;
      align-items: flex-start;
      justify-content: flex-start;
      flex-shrink: 0;
      position: relative;
      flex-shrink: 0;
      width: 37px;
      height: auto;
      position: relative;
      img {
        // width: 32px;
        height: 50px;
      }
    }
    .content {
      display: flex;
      flex-direction: column;
      gap: 10px;
      align-items: flex-start;
      justify-content: flex-start;
      align-self: stretch;
      flex: 1;
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 0px;
      align-items: flex-start;
      justify-content: flex-start;
      align-self: stretch;
      flex-shrink: 0;
      position: relative;
    }
    .title {
      display: flex;
      flex-direction: row;
      gap: 0px;
      align-items: flex-start;
      justify-content: flex-start;
      align-self: stretch;
      flex-shrink: 0;
      position: relative;
      color: var(--default-500, #1e1e1e);
      text-align: left;
      font-family: var(
        --raelingen-h3-font-family,
        "SourceSansPro-SemiBold",
        sans-serif
      );
      font-size: var(--raelingen-h3-font-size, 20px);
      line-height: var(--raelingen-h3-line-height, 150%);
      font-weight: var(--raelingen-h3-font-weight, 600);
      position: relative;
      flex: 1;
    }
    .text {
      color: var(--default-500, #1e1e1e);
      text-align: left;
      font-family: "SourceSansPro-Regular", sans-serif;
      font-size: 16px;
      line-height: 135%;
      font-weight: 400;
      position: relative;
      align-self: stretch;
    }
    .more-icon {
      display: flex;
      flex-direction: column;
      gap: 10px;
      align-items: flex-end;
      justify-content: center;
      align-self: stretch;
      flex-shrink: 0;
      position: relative;
    }
    .arrow-forward {
      flex-shrink: 0;
      width: 32px;
      height: 32px;
      position: relative;
      overflow: visible;
    }
    .pill {
      background: #eeeeee;
      border-radius: 40px;
      padding: 4px 11px 4px 11px;
    }
    .amount {
      font-weight: 600;
    }
    .paid {
      background: #d6f3c0;
    }`;

	// constructor() {
	//   super();
	// }

	render () {
		return html`${this.message}`;
	}
}

customElements.define("mypage-messages", MyPageMessages);
customElements.define("mypage-messages-filter", MyPageMessagesFilter);
customElements.define("mypage-messages-list", MyPageMessagesList);
customElements.define("mypage-message-item", MyPageMessageItem);
customElements.define("mypage-message-error", MyPageMessageError);

const getMessages = async (year) => {
	if (!window.location.host.match(/localhost/gim)) {
		return ensureLogedin().then(async (accessToken) => {
			const fiksOrgId = window.serverdata.configMeta?.integrations?.fiksOrgId;
			const apiUrl = window.apiUrl.replace("/api", "/proxy");
			const apiCall = `${apiUrl}/ksfiks/innsyn/post/sok`;
			const apiParameters = "?fra=0&antall=25&sortering=DATO_DESC&akseptertMeldingVersjon=forsendelseV2";
			const body = {
				fraDato: `${year}-01-01`,
				tilDato: `${year}-12-31`,
				fiksOrganisasjon: [fiksOrgId],
			};

			return await fetch(apiCall + apiParameters, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					SubscriptionId: `${window.serverdata.configMeta.aim.clientId}`,
					Authorization: `Bearer ${accessToken}`,
				},
				body: JSON.stringify(body),
			})
				.then((results) => {
					if (results.ok) {
						return results.json();
					}
					return results.text();
				})
				.then((data) => {
					return data;
				})
				.catch((error) => {
					console.log(error.status, error.statusText);
				});
		});
	}
	return JSON.parse(`
			{
				"antallTreff": 5,
				"treffMedHoyereInnloggingsniva": 0,
				"harMeldingerMedHoyereSikkerhetsniva": false,
				"treff": [
						{
								"meldingId": "dd43c769-049e-377c-b958-8ac835ad0b6a",
								"dokumentId": "c9b3a1f7-4589-484b-b391-0f4a632b8b98_58b23c08-e6cd-4908-affb-4dd95db764d4_forsendelse_dd43c769-049e-377c-b958-8ac835ad0b6a",
								"sikkerhetsniva": 3,
								"fiksOrganisasjon": {
										"id": "c9b3a1f7-4589-484b-b391-0f4a632b8b98",
										"visningsnavn": "Rælingen kommune",
										"kommunenummer": "3224"
								},
								"sorteringDato": "2022-08-22T13:31:05.589+02:00",
								"eksternRef": "0228_Fakturering",
								"meldingMetadata": {
										"tittel": "Faktura kommunale gebyrer",
										"avsender": "Rælingen kommune",
										"mottakerAdresse": {
												"navn": "HANSSEN RONNY",
												"addresselinje1": "GRENSEVEGEN 2",
												"addresselinje2": "",
												"addresselinje3": "",
												"poststed": "RÆLINGEN",
												"postnummer": "2005",
												"land": ""
										},
										"returAdresse": null,
										"svarLenke": null,
										"sendtDato": "2022-08-22T13:31:05.589+02:00",
										"lest": false,
										"dokumenter": [
												{
														"tittel": "807.pdf",
														"size": 184772,
														"nedlastingLenke": "https://min.kommune.no/forsendelse/1dc5b24d-1f81-49b2-9651-cec3a452b706/1",
														"mimeType": "application/pdf"
												},
												{
														"tittel": "808.pdf",
														"size": 184772,
														"nedlastingLenke": "https://min.kommune.no/forsendelse/1dc5b24d-1f81-49b2-9651-cec3a452b706/2",
														"mimeType": "application/pdf"
												}
										],
										"lenker": [],
										"versjon": "forsendelseV2",
										"type": "forsendelse"
								},
								"score": 0.79292554
						},
						{
								"meldingId": "6805bca0-5d7e-3bfd-9c20-34b81457a82b",
								"dokumentId": "c9b3a1f7-4589-484b-b391-0f4a632b8b98_58b23c08-e6cd-4908-affb-4dd95db764d4_forsendelse_6805bca0-5d7e-3bfd-9c20-34b81457a82b",
								"sikkerhetsniva": 3,
								"fiksOrganisasjon": {
										"id": "c9b3a1f7-4589-484b-b391-0f4a632b8b98",
										"visningsnavn": "Rælingen kommune",
										"kommunenummer": "3224"
								},
								"sorteringDato": "2022-02-22T12:13:10.523+01:00",
								"eksternRef": "0228_Fakturering",
								"meldingMetadata": {
										"tittel": "Faktura",
										"avsender": "Rælingen kommune",
										"mottakerAdresse": {
												"navn": "HANSSEN RONNY",
												"addresselinje1": "GRENSEVEGEN 2",
												"addresselinje2": "",
												"addresselinje3": "",
												"poststed": "RÆLINGEN",
												"postnummer": "2005",
												"land": ""
										},
										"returAdresse": null,
										"svarLenke": null,
										"sendtDato": "2022-02-22T12:13:10.523+01:00",
										"lest": false,
										"dokumenter": [
												{
														"tittel": "781.pdf",
														"size": 179325,
														"nedlastingLenke": "https://min.kommune.no/forsendelse/28fadc37-4f6e-4157-893f-c21570fab798/1",
														"mimeType": "application/pdf"
												}
										],
										"lenker": [],
										"versjon": "forsendelseV2",
										"type": "forsendelse"
								},
								"score": 0.7372742
						},
						{
								"meldingId": "ee8e502d-d8a4-3d75-b075-20cf6a406a09",
								"dokumentId": "c9b3a1f7-4589-484b-b391-0f4a632b8b98_58b23c08-e6cd-4908-affb-4dd95db764d4_forsendelse_ee8e502d-d8a4-3d75-b075-20cf6a406a09",
								"sikkerhetsniva": 3,
								"fiksOrganisasjon": {
										"id": "c9b3a1f7-4589-484b-b391-0f4a632b8b98",
										"visningsnavn": "Rælingen kommune",
										"kommunenummer": "3224"
								},
								"sorteringDato": "2021-08-26T11:10:18.157+02:00",
								"eksternRef": "0228_Fakturering",
								"meldingMetadata": {
										"tittel": "Faktura kommunale avgifter",
										"avsender": "Rælingen kommune",
										"mottakerAdresse": {
												"navn": "HANSSEN RONNY",
												"addresselinje1": "GRENSEVEGEN 2",
												"addresselinje2": "",
												"addresselinje3": "",
												"poststed": "RÆLINGEN",
												"postnummer": "2005",
												"land": ""
										},
										"returAdresse": null,
										"svarLenke": null,
										"sendtDato": "2021-08-26T11:10:18.157+02:00",
										"lest": false,
										"dokumenter": [
												{
														"tittel": "767.pdf",
														"size": 179744,
														"nedlastingLenke": "https://min.kommune.no/forsendelse/2c9583b5-8cea-453b-be8a-416009fbf765/1",
														"mimeType": "application/pdf"
												}
										],
										"lenker": [],
										"versjon": "forsendelseV2",
										"type": "forsendelse"
								},
								"score": 0.68578434
						},
						{
								"meldingId": "a7a83298-603b-333e-90d5-69b577a85608",
								"dokumentId": "c9b3a1f7-4589-484b-b391-0f4a632b8b98_58b23c08-e6cd-4908-affb-4dd95db764d4_forsendelse_a7a83298-603b-333e-90d5-69b577a85608",
								"sikkerhetsniva": 3,
								"fiksOrganisasjon": {
										"id": "c9b3a1f7-4589-484b-b391-0f4a632b8b98",
										"visningsnavn": "Rælingen kommune",
										"kommunenummer": "3224"
								},
								"sorteringDato": "2021-02-22T11:40:36.454+01:00",
								"eksternRef": "0228_Fakturering",
								"meldingMetadata": {
										"tittel": "Faktura kommunale avgifter",
										"avsender": "Rælingen kommune",
										"mottakerAdresse": {
												"navn": "HANSSEN RONNY",
												"addresselinje1": "GRENSEVEGEN 2",
												"addresselinje2": "",
												"addresselinje3": "",
												"poststed": "RÆLINGEN",
												"postnummer": "2005",
												"land": ""
										},
										"returAdresse": null,
										"svarLenke": null,
										"sendtDato": "2021-02-22T11:40:36.454+01:00",
										"lest": false,
										"dokumenter": [
												{
														"tittel": "801.pdf",
														"size": 179664,
														"nedlastingLenke": "https://min.kommune.no/forsendelse/4119ae75-bc77-42c7-9440-54c3a4eab788/1",
														"mimeType": "application/pdf"
												}
										],
										"lenker": [],
										"versjon": "forsendelseV2",
										"type": "forsendelse"
								},
								"score": 0.63664734
						},
						{
								"meldingId": "d216552d-df5a-3f4f-a654-1150fa3657a7",
								"dokumentId": "c9b3a1f7-4589-484b-b391-0f4a632b8b98_58b23c08-e6cd-4908-affb-4dd95db764d4_forsendelse_d216552d-df5a-3f4f-a654-1150fa3657a7",
								"sikkerhetsniva": 3,
								"fiksOrganisasjon": {
										"id": "c9b3a1f7-4589-484b-b391-0f4a632b8b98",
										"visningsnavn": "Rælingen kommune",
										"kommunenummer": "3224"
								},
								"sorteringDato": "2021-02-22T11:40:35.758+01:00",
								"eksternRef": "0228_Fakturering",
								"meldingMetadata": {
										"tittel": "Faktura kommunale avgifter",
										"avsender": "Rælingen kommune",
										"mottakerAdresse": {
												"navn": "HANSSEN RONNY",
												"addresselinje1": "GRENSEVEGEN 2",
												"addresselinje2": "",
												"addresselinje3": "",
												"poststed": "RÆLINGEN",
												"postnummer": "2005",
												"land": ""
										},
										"returAdresse": null,
										"svarLenke": null,
										"sendtDato": "2021-02-22T11:40:35.758+01:00",
										"lest": false,
										"dokumenter": [
												{
														"tittel": "800.pdf",
														"size": 115953,
														"nedlastingLenke": "https://min.kommune.no/forsendelse/1394659a-6505-4d70-9ae4-df0249f9e7a6/1",
														"mimeType": "application/pdf"
												}
										],
										"lenker": [],
										"versjon": "forsendelseV2",
										"type": "forsendelse"
								},
								"score": 0.63664734
						}
				],
				"forespurtFra": 0,
				"forespurtAntall": 15,
				"aggregeringer": {
						"fiksOrganisasjon": [
								{
										"fiksOrg": {
												"id": "c9b3a1f7-4589-484b-b391-0f4a632b8b98",
												"visningsnavn": "Rælingen kommune"
										},
										"antallTreff": 5
								}
						],
						"dateRange": {
								"fraDato": "2021-02-22T11:40:35.758+01:00",
								"tilDato": "2022-08-22T13:31:05.589+02:00"
						}
				}
		}
		`);
};
